export const filterTeamsByName = <T extends { name: string }>(teams: readonly T[], search: string): T[] => {
  const normalizedSearch = search.toLowerCase();

  return teams.filter((team) => team.name.toLowerCase().includes(normalizedSearch));
};
